<div>
    <div class="row">
        <div class="form-group col-md-3">
            <label class="label-info">Année scolaire</label>
            <input [value]="this.getSchoolYear()" class="form-control" disabled readonly/>

        </div>
        <div class="form-group col-md-6">
            <label class="label-info">Établissement</label>
            <input [(ngModel)]="schoolLevel.schoolName" class="form-control"
                   type="search">
        </div>
    </div>

    <div class="row">
        <div class="form-group col-md-4">
            <label class="label-info star">Classe</label>
            <select (change)="emitChangeActivForm()"
                    [(ngModel)]="chosenSchoolLevel"
                    (ngModelChange)="onChangeLevel($event)"
                    [compareWith]="compareSchoolLevel"
                    class="form-control b">
                <option *ngFor="let item of this.schoolLevels" [ngValue]="item"
                        class="no-white-space">{{item.label}}</option>
            </select>
        </div>

        <div *ngIf="hasSpeciality && schoolLevelSpeciality && schoolLevelSpeciality.length > 0"
             class="form-group col-md-4">
            <label class="label-info">Filière</label>
            <select (change)="emitChangeActivForm()"
                    [(ngModel)]="chosenSpeciality"
                    (ngModelChange)="onChangeSpeciality($event)"
                    [compareWith]="compareSchoolLevel"
                    class="form-control b">
                <option *ngFor="let item of schoolLevelSpeciality" [ngValue]="item"
                        class="no-white-space">{{item.label}}</option>
            </select>
        </div>

        <div *ngIf="hasDomain && schoolLevelDomain && schoolLevelDomain.length > 0" class="form-group col-md-4">
            <label class="label-info">Spécialité</label>
            <select (change)="emitChangeActivForm()"
                    [(ngModel)]="chosenDomain"
                    (ngModelChange)="setSchoolLevel($event)"
                    [compareWith]="compareSchoolLevel"
                    class="form-control b"
            >
                <option *ngFor="let item of schoolLevelDomain" [ngValue]="item"
                        class="no-white-space">{{item.label}}</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-md-8">
            <label class="label-info">Intitulé formation</label>
            <input (keydown)="emitChangeActivForm()" [(ngModel)]="schoolLevel.schoolClass" class="form-control"
                   type="search">
        </div>
    </div>

</div>
